import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#debt-relief-2-app', App, 'full');
